import { State, intervalNumMap, intervalStrMap } from "../state/state";
import { Mask, Commands, CommandServer, MaskServer } from "../../../shared";

export const fromServer = (
  key: string,
  data: State.TimerServer
): State.Timer => {
  let date = new Date(data.start * 1000);
  let cmds: Commands<Mask> = {};
  data.cmds.forEach(cmd => (cmds[cmd.url] = cmd.data.mask.split("") as Mask));
  const ret = {
    label: key,
    interval: intervalNumMap[data.interval],
    startDate: date.toISOString().split("T")[0],
    startTime: `${date.toTimeString().split(" ")[0]}`,
    cmds: cmds
  };
  return ret;
};

export const toServer = (
  data: Partial<State.Timer>
): Partial<State.TimerServer> => {
  let ret: Partial<State.TimerServer> = {};
  let cmds: CommandServer<MaskServer>[] = [];
  if (data.interval) ret.interval = intervalStrMap[data.interval];
  if (data.startTime && data.startDate) {
    ret.start = Date.parse(`${data.startDate} ${data.startTime}`) / 1000;
  }
  if (data.cmds != null) {
    for (let key in data.cmds) {
      let mask = data.cmds[key].join("");
      cmds.push({
        url: key,
        data: { mask: mask }
      });
    }
    ret.cmds = cmds;
  }
  return ret;
};
